import type { FetcherAxiosInstance } from '../fetcher';

export const createABTestApi = (Fetcher: FetcherAxiosInstance) => ({
  getAbTest() {
    return Fetcher('/tests/get-tests');
  },
});
